import React from "react";

import SectionTitle from "../general/SectionTitle";

//Heading, then rows of text beside a photo - the photo swaps sides on each row, as on Wix
const IntroSection = ({ title, rows }) => (
  <section className={"intro-section"}>
    <div className={"container"}>
      <SectionTitle>{title}</SectionTitle>
      {rows.map((row, i) => (
        <div
          key={row.image.src}
          className={`intro-row ${i % 2 === 1 ? "is-reversed" : ""}`}
        >
          <div className={"intro-text"}>
            {row.paragraphs.map((p) => <p key={p}>{p}</p>)}
            {row.listTitle ? <p className={"intro-list-title"}>{row.listTitle}</p> : null}
            {row.list ? (
              <ul className={"intro-list"}>
                {row.list.map((item) => <li key={item}>{item}</li>)}
              </ul>
            ) : null}
          </div>
          <div className={"intro-photo"}>
            <img
              src={row.image.src}
              alt={row.image.alt}
              width={row.image.width}
              height={row.image.height}
              loading={"lazy"}
            />
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default IntroSection;
